import { addToGlobalThisRet } from "@plugins";

const tooltipOptions = {
    placement: "bottom",
};

function addContactsDataCount() {
    const contactsDataWraps = document.querySelectorAll(".js-employee-card-contacts-data-wrap");

    if (contactsDataWraps) {
        contactsDataWraps.forEach((wrap) => {
            if (wrap.children.length > 3) {
                const children = Array.from(wrap.children);
                const count = document.createElement("span");
                count.classList.add(
                    "employee-card__contacts-data-count",
                    "js-employee-card-sites-tooltip-init",
                );
                count.dataset.tooltipTarget = "";
                count.innerHTML = `+${wrap.children.length - 3}`;
                wrap.appendChild(count);

                addContactsDataTooltipContent(count, children);
            }
        });
    }
}

function addContactsDataTooltipContent(count, children) {
    const sites = [];
    children.forEach((child) => {
        const childLink = `<a href="#" class="tooltip__sites-link">${child.textContent}</a>`;
        sites.push(childLink);
    });
    const newSites = sites.join(" ");
    count.insertAdjacentHTML(
        "beforeend",
        `
            <div class="tooltip" data-tooltip-content>
                <div class="tooltip__content">
                    <div class="tooltip__sites-list">
                        ${newSites}
                    </div>
                </div>
            </div>
        `,
    );
}

window.addEventListener("load", () => {
    addContactsDataCount();
    globalThis.ret.initContentTooltips(".js-employee-card-sites-tooltip-init", tooltipOptions);
    globalThis.ret.initContentTooltips(".js-employee-card-contacts-tooltip-init", tooltipOptions);
});

addToGlobalThisRet(addContactsDataCount, "addContactsDataCount");
